import React, { useEffect, useState } from 'react';
import Layout from '../../../components/layout';
import Header from '../../../components/header';
import { Controller, useForm, SubmitHandler } from 'react-hook-form';
import Button from '../../../components/elements/button';
import { useSagesApi } from '../../../store/api/hooks/sageApiHook';
import toast from 'react-hot-toast';
import { useAppLoader } from '../../../_common/pageLoader/appLoaderHook';
import SelectBox from '../../../components/elements/form/selectBox';
import Loader from '../../../components/loader';

type ConectorsFormValueType = {
    assetCIPAccountGroupID?: any;
    assetCIPAccountID?: any;
    assetRevaluationAccountGroupID?: any;
    assetRevaluationAccountID?: any;
    assetDisposalAccountGroupID?: any;
    assetDisposalAccountID?: any;
    assetExpensesAccountGroupID?: any;
    assetExpensesAccountID?: any;
    disposalProceedAccountGroupID?: any;
    disposalProceedAccountID?: any;
    apClearingAccountGroupID?: any;
    apClearingAccountID?: any;
    inventoryAccountGroupID?: any;
    inventoryAccountID?: any;
    accountsPayableAccountGroupID?: any;
    accountsPayableAccountID?: any;
    vendorAccountGroupID?: any;
    vendorAccountID?: any;
};

const SageOtherMapping: React.FC = () => {
    const sageApi: any = useSagesApi();
    const { control, handleSubmit, setValue, reset, watch } = useForm<ConectorsFormValueType>({
        defaultValues: {},
    });
    const { showLoader, hideLoader } = useAppLoader();
    const [accGroupOption, setAccGroupOption] = useState<any[]>([]);
    const [cipAccOption, setCipAccOption] = useState<any[]>([]);
    const [revalAccOption, setRevalAccOption] = useState<any[]>([]);
    const [disposalAccOption, setDisposalAccOption] = useState<any[]>([]);
    const [lossAccOption, setLossAccOption] = useState<any[]>([]);
    const [cashBankAccOption, setCashBankAccOption] = useState<any[]>([]);
    const [apClearingAccOption, setApClearingAccOption] = useState<any[]>([]);
    const [inventoryAccOption, setInventoryAccOption] = useState<any[]>([]);
    const [apAccOption, setApAccOption] = useState<any[]>([]);
    const [vendorAccOption, setVendorAccOption] = useState<any[]>([]);
    const [defaultMapID, setDefaultMapID] = useState<string | null>(null);
    const [prefillDone, setPrefillDone] = useState(false);

    const defaultSelectOption = { label: 'Select an option', value: '' };

    const formReset = () => {
        reset({
            assetCIPAccountGroupID: '',
            assetCIPAccountID: '',
            assetRevaluationAccountGroupID: '',
            assetRevaluationAccountID: '',
            assetDisposalAccountGroupID: '',
            assetDisposalAccountID: '',
            assetExpensesAccountGroupID: '',
            assetExpensesAccountID: '',
            disposalProceedAccountGroupID: '',
            disposalProceedAccountID: '',
            apClearingAccountGroupID: '',
            apClearingAccountID: '',
            inventoryAccountGroupID: '',
            inventoryAccountID: '',
            accountsPayableAccountGroupID: '',
            accountsPayableAccountID: '',
            vendorAccountGroupID: '',
            vendorAccountID: [],
        });
    };

    const onSubmit: SubmitHandler<ConectorsFormValueType> = formData => {
        showLoader();
        const payload: any = {
            assetCIPAccountGroupID: formData.assetCIPAccountGroupID?.value || '',
            assetCIPAccountID: formData.assetCIPAccountID?.value || '',
            assetRevaluationAccountGroupID: formData.assetRevaluationAccountGroupID?.value || '',
            assetRevaluationAccountID: formData.assetRevaluationAccountID?.value || '',
            assetDisposalAccountGroupID: formData.assetDisposalAccountGroupID?.value || '',
            assetDisposalAccountID: formData.assetDisposalAccountID?.value || '',
            assetExpensesAccountGroupID: formData.assetExpensesAccountGroupID?.value || '',
            assetExpensesAccountID: formData.assetExpensesAccountID?.value || '',
            disposalProceedAccountGroupID: formData.disposalProceedAccountGroupID?.value || '',
            disposalProceedAccountID: formData.disposalProceedAccountID?.value || '',
            apClearingAccountGroupID: formData.apClearingAccountGroupID?.value || '',
            apClearingAccountID: formData.apClearingAccountID?.value || '',
            inventoryAccountGroupID: formData.inventoryAccountGroupID?.value || '',
            inventoryAccountID: formData.inventoryAccountID?.value || '',
            accountsPayableAccountGroupID: formData.accountsPayableAccountGroupID?.value || '',
            accountsPayableAccountID: formData.accountsPayableAccountID?.value || '',
            vendorAccountGroupID: formData.vendorAccountGroupID?.value || '',
            vendorAccountIDList:
                formData.vendorAccountID?.map((v: any) => ({
                    vendorAccountID: v.value
                })) || []

        };
        console.log(payload);

        if (defaultMapID) {
            payload.sageDefaultAccountMapID = defaultMapID;
        }

        sageApi.saveAssetOtherMapping(payload, (resp: any) => {
            hideLoader();
            if (resp.successful) {
                formReset();
                toast.success(resp?.message);
                setPrefillDone(false);
                getAssetOtherMapping();
            } else {
                toast.error(resp.message || "Connection Failed");
            }
        }, (error: any) => {
            hideLoader();
            toast.error(error);
        });
    };

    const getAccountList = (accountGroupID: string, setAccountOptions: Function) => {
        if (!accountGroupID) {
            setAccountOptions([defaultSelectOption]);
            return;
        }
        sageApi.getSyncAccount(
            { pageSize: 0, accountGroupID },
            (resp: any) => {
                const options = [
                    defaultSelectOption,
                    ...(resp.sageAccountList?.map((acc: any) => ({
                        label: acc.accountTitle,
                        value: acc.accountID,
                    })) || [])
                ];
                setAccountOptions(options);
            },
            toast.error
        );
    };

    const getAssetOtherMapping = () => {
        sageApi.getSyncAccountGroups({ pageSize: 0 }, (groupResp: any) => {
            const accGroupOpts = [
                defaultSelectOption,
                ...(groupResp.sageAccountGroupList?.map((group: any) => ({
                    label: group.accountGroupName,
                    value: group.accountGroupID,
                })) || [])
            ];

            setAccGroupOption(accGroupOpts);

            sageApi.getAssetOtherMapping({ pageSize: 0 }, async (resp: any) => {
                //const data = resp.sageAssetAccountMapping?.[0];
                const data = resp;
                if (!data) {
                    hideLoader();
                    return;
                }

                if (data.sageDefaultAccountMapID) {
                    setDefaultMapID(data.sageDefaultAccountMapID);
                }

                const findGroup = (id: number) =>
                    accGroupOpts.find((g: any) => g.value === id) || defaultSelectOption;

                const loadAccount = (
                    groupId: number,
                    accountId: number | number[],
                    setOptFn: any,
                    setName: keyof ConectorsFormValueType,
                    isMulti = false
                ) => {
                    return new Promise<void>((resolve) => {
                        sageApi.getSyncAccount(
                            { pageSize: 0, accountGroupID: groupId },
                            (accResp: any) => {
                                const accOpts = [
                                    defaultSelectOption,
                                    ...(accResp.sageAccountList?.map((acc: any) => ({
                                        label: acc.accountTitle,
                                        value: acc.accountID,
                                    })) || [])
                                ];
                                setOptFn(accOpts);

                                let selected;
                                if (isMulti) {
                                    selected = Array.isArray(accountId)
                                        ? accountId
                                            .map(id => accOpts.find((a: any) => a.value === id))
                                            .filter(Boolean)
                                        : [];
                                } else {
                                    selected = accOpts.find((a: any) => a.value === accountId) || defaultSelectOption;
                                }

                                setValue(setName, selected);
                                resolve();
                            },
                            (err: any) => {
                                toast.error(err);
                                resolve();
                            }
                        );
                    });
                };

                // Prefill all fields in parallel
                await Promise.all([
                    setValue('assetCIPAccountGroupID', findGroup(data.assetCIPAccountGroupID)),
                    loadAccount(data.assetCIPAccountGroupID, data.assetCIPAccountID, setCipAccOption, 'assetCIPAccountID'),

                    setValue('assetRevaluationAccountGroupID', findGroup(data.assetRevaluationAccountGroupID)),
                    loadAccount(data.assetRevaluationAccountGroupID, data.assetRevaluationAccountID, setRevalAccOption, 'assetRevaluationAccountID'),

                    setValue('assetDisposalAccountGroupID', findGroup(data.assetDisposalAccountGroupID)),
                    loadAccount(data.assetDisposalAccountGroupID, data.assetDisposalAccountID, setDisposalAccOption, 'assetDisposalAccountID'),

                    setValue('assetExpensesAccountGroupID', findGroup(data.assetExpensesAccountGroupID)),
                    loadAccount(data.assetExpensesAccountGroupID, data.assetExpensesAccountID, setLossAccOption, 'assetExpensesAccountID'),

                    setValue('disposalProceedAccountGroupID', findGroup(data.disposalProceedAccountGroupID)),
                    loadAccount(data.disposalProceedAccountGroupID, data.disposalProceedAccountID, setCashBankAccOption, 'disposalProceedAccountID'),

                    setValue('apClearingAccountGroupID', findGroup(data.apClearingAccountGroupID)),
                    loadAccount(data.apClearingAccountGroupID, data.apClearingAccountID, setApClearingAccOption, 'apClearingAccountID'),

                    setValue('inventoryAccountGroupID', findGroup(data.inventoryAccountGroupID)),
                    loadAccount(data.inventoryAccountGroupID, data.inventoryAccountID, setInventoryAccOption, 'inventoryAccountID'),

                    setValue('accountsPayableAccountGroupID', findGroup(data.accountsPayableAccountGroupID)),
                    loadAccount(data.accountsPayableAccountGroupID, data.accountsPayableAccountID, setApAccOption, 'accountsPayableAccountID'),

                    setValue('vendorAccountGroupID', findGroup(data.vendorAccountGroupID)),
                    loadAccount(
                        data.vendorAccountGroupID,
                        data.vendorAccountListModel?.map((v: any) => v.vendorAccountID),
                        setVendorAccOption,
                        'vendorAccountID',
                        true
                    )

                ]);

                setPrefillDone(true);
                hideLoader();
            }, (err: any) => {
                toast.error(err);
                hideLoader();
            });
        }, (err: any) => {
            toast.error(err);
            hideLoader();
        });
    };


    useEffect(() => {
        setPrefillDone(false);
        getAssetOtherMapping();
    }, []);

    useEffect(() => {
        const subscription = watch((value, { name }) => {
            if (!prefillDone) return;

            if (name === 'assetCIPAccountGroupID') {
                // Clear account field
                setValue('assetCIPAccountID', defaultSelectOption);
                if (value.assetCIPAccountGroupID?.value) {
                    getAccountList(value.assetCIPAccountGroupID.value, setCipAccOption);
                } else {
                    setCipAccOption([defaultSelectOption]);
                }
            }

            if (name === 'assetRevaluationAccountGroupID') {
                setValue('assetRevaluationAccountID', defaultSelectOption);
                if (value.assetRevaluationAccountGroupID?.value) {
                    getAccountList(value.assetRevaluationAccountGroupID.value, setRevalAccOption);
                } else {
                    setRevalAccOption([defaultSelectOption]);
                }
            }

            if (name === 'assetDisposalAccountGroupID') {
                setValue('assetDisposalAccountID', defaultSelectOption);
                if (value.assetDisposalAccountGroupID?.value) {
                    getAccountList(value.assetDisposalAccountGroupID.value, setDisposalAccOption);
                } else {
                    setDisposalAccOption([defaultSelectOption]);
                }
            }

            if (name === 'assetExpensesAccountGroupID') {
                setValue('assetExpensesAccountID', defaultSelectOption);
                if (value.assetExpensesAccountGroupID?.value) {
                    getAccountList(value.assetExpensesAccountGroupID.value, setLossAccOption);
                } else {
                    setLossAccOption([defaultSelectOption]);
                }
            }

            if (name === 'disposalProceedAccountGroupID') {
                setValue('disposalProceedAccountID', defaultSelectOption);
                if (value.disposalProceedAccountGroupID?.value) {
                    getAccountList(value.disposalProceedAccountGroupID.value, setCashBankAccOption);
                } else {
                    setCashBankAccOption([defaultSelectOption]);
                }
            }

            if (name === 'apClearingAccountGroupID') {
                setValue('apClearingAccountID', defaultSelectOption);
                if (value.apClearingAccountGroupID?.value) {
                    getAccountList(value.apClearingAccountGroupID.value, setApClearingAccOption);
                } else {
                    setApClearingAccOption([defaultSelectOption]);
                }
            }

            if (name === 'inventoryAccountGroupID') {
                setValue('inventoryAccountID', defaultSelectOption);
                if (value.inventoryAccountGroupID?.value) {
                    getAccountList(value.inventoryAccountGroupID.value, setInventoryAccOption);
                } else {
                    setInventoryAccOption([defaultSelectOption]);
                }
            }

            if (name === 'accountsPayableAccountGroupID') {
                setValue('accountsPayableAccountID', defaultSelectOption);
                if (value.accountsPayableAccountGroupID?.value) {
                    getAccountList(value.accountsPayableAccountGroupID.value, setApAccOption);
                } else {
                    setApAccOption([defaultSelectOption]);
                }
            }

            if (name === 'vendorAccountGroupID') {
                setValue('vendorAccountID', []);
                if (value.vendorAccountGroupID?.value) {
                    getAccountList(value.vendorAccountGroupID.value, setVendorAccOption);
                } else {
                    setVendorAccOption([defaultSelectOption]);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [prefillDone]);

    return (
        <Layout>
            <Header title="Sync Master data from Sage Intacct" back="/settings" />
            <div className={`relative`}>
                {!prefillDone ? (
                    <div className="flex justify-center items-center min-h-[calc(100vh-100px)] bg-gray-100 px-4 py-8">
                        <Loader />
                    </div>
                ) : (
                    <div className="flex justify-center items-center min-h-[calc(100vh-100px)] bg-gray-100 px-4 py-8">
                        <div className="bg-white shadow-lg rounded-xl p-8 w-full max-w-xxl">
                            <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
                                <div className="grid grid-cols-3 gap-x-4 items-center font-semibold mb-1">
                                    <div>Purpose in CMMS</div>
                                    <div>Account Group</div>
                                    <div>Account</div>
                                </div>

                                <div className="grid grid-cols-3 gap-x-4 items-center gap-y-4">
                                    <label className="font-semibold self-center">Select Assets CIP / WIP Account</label>
                                    <Controller name="assetCIPAccountGroupID" control={control} render={({ field }) => <SelectBox {...field} options={accGroupOption} />} />
                                    <Controller name="assetCIPAccountID" control={control} render={({ field }) => <SelectBox {...field} options={cipAccOption} />} />

                                    {/* <label className="font-semibold">Select Assets Revaluation Reserve Account</label> */}
                                    <label className="font-semibold">Gain or Loss on Sale of Asset</label>
                                    <Controller name="assetRevaluationAccountGroupID" control={control} render={({ field }) => <SelectBox {...field} options={accGroupOption} />} />
                                    <Controller name="assetRevaluationAccountID" control={control} render={({ field }) => <SelectBox {...field} options={revalAccOption} />} />

                                    {/* <label className="font-semibold">Asset Disposal (Proceeds Gain / Loss)</label>
                                    <Controller name="assetDisposalAccountGroupID" control={control} render={({ field }) => <SelectBox {...field} options={accGroupOption} />} />
                                    <Controller name="assetDisposalAccountID" control={control} render={({ field }) => <SelectBox {...field} options={disposalAccOption} />} />

                                    <label className="font-semibold">Loss on Disposal (Expense)</label>
                                    <Controller name="assetExpensesAccountGroupID" control={control} render={({ field }) => <SelectBox {...field} options={accGroupOption} />} />
                                    <Controller name="assetExpensesAccountID" control={control} render={({ field }) => <SelectBox {...field} options={lossAccOption} />} />

                                    <label className="font-semibold">Cash / Bank for Disposal Proceeds</label>
                                    <Controller name="disposalProceedAccountGroupID" control={control} render={({ field }) => <SelectBox {...field} options={accGroupOption} />} />
                                    <Controller name="disposalProceedAccountID" control={control} render={({ field }) => <SelectBox {...field} options={cashBankAccOption} />} />

                                    <label className="font-semibold">AP Clearing Account</label>
                                    <Controller name="apClearingAccountGroupID" control={control} render={({ field }) => <SelectBox {...field} options={accGroupOption} />} />
                                    <Controller name="apClearingAccountID" control={control} render={({ field }) => <SelectBox {...field} options={apClearingAccOption} />} /> */}

                                    <label className="font-semibold">Inventory Account</label>
                                    <Controller name="inventoryAccountGroupID" control={control} render={({ field }) => <SelectBox {...field} options={accGroupOption} />} />
                                    <Controller name="inventoryAccountID" control={control} render={({ field }) => <SelectBox {...field} options={inventoryAccOption} />} />

                                    {/* <label className="font-semibold">Accounts Payable</label>
                                    <Controller name="accountsPayableAccountGroupID" control={control} render={({ field }) => <SelectBox {...field} options={accGroupOption} />} />
                                    <Controller name="accountsPayableAccountID" control={control} render={({ field }) => <SelectBox {...field} options={apAccOption} />} /> */}

                                    <label className="font-semibold self-center">Vendors</label>
                                    <Controller name="vendorAccountGroupID" control={control} render={({ field }) => <SelectBox {...field} options={accGroupOption} />} />
                                    <Controller name="vendorAccountID" control={control} render={({ field }) => <SelectBox {...field} options={vendorAccOption} isMulti={true} />} />
                                </div>

                                <div className="flex justify-end gap-2 pt-4 border-t border-gray-200">
                                    {/* <Button type="button" theme="secondary" onClick={formReset}>Reset</Button> */}
                                    <Button type="submit">Save</Button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </Layout>
    );
};

export default SageOtherMapping;